import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { IBrandResources } from 'src/app/domain/interfaces/brand/interface-brand-resources';
import { Loading } from 'src/app/domain/models/alert/loading';
import { BrandService } from 'src/app/infraestructure/drive-adapter/brand-service/brand.service';
import { Alert } from '../../../domain/models/alert/alert';
import { AlertPosition, AlertType } from '../../../domain/models/alert/alert-type-enum';
import { AlertService } from '../../../infraestructure/drive-adapter/alert-service/alert.service';
import { LoadingType } from 'src/app/domain/models/alert/loading-type-enum';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-alert',
  templateUrl: 'alert.component.html',
  styleUrls: ['alert.component.scss'],
})
export class AlertComponent implements OnInit, OnDestroy {
  @Input() id: string = 'default-alert';
  public alerts: Array<Alert> = [];
  private alertSubscription!: Subscription;
  private loadingSubscription!: Subscription;
  private routeSubscription!: Subscription;
  public showAsModal?: boolean;
  public loading?: Loading;
  public AlertType = AlertType;
  public LoadingType = LoadingType;
  public brandResources!: IBrandResources;
  public environment = environment;

  constructor(private router: Router, private alertService: AlertService, private brandService: BrandService) {}

  ngOnInit() {
    this.brandService.getBrandResources().subscribe((brandResourcesResponse: IBrandResources) => {
      this.brandResources = brandResourcesResponse;
    });
    this.alertSubscription = this.alertService.onAlert(this.id).subscribe((alertToShow: Alert) => {
      if (!alertToShow.Description) {
        this.removeAlert(alertToShow);
        return;
      }
      const alertTypeTitle = {
        [AlertType.InfoLogo]: '',
        [AlertType.Success]: 'SUCCESS',
        [AlertType.Error]: 'Oops...',
        [AlertType.Info]: 'INFORMATION',
        [AlertType.Warning]: 'WARNING',
      };

      this.showAsModal = alertToShow.ShowAsModal;
      if (!alertToShow.Title) alertToShow.Title = alertTypeTitle[alertToShow.Type!];

      if (!this.alerts.some((c) => c.Description === alertToShow.Description))
        this.alerts.push(alertToShow);

      if (alertToShow.AutoClose) {
        setTimeout(() => this.removeAlert(alertToShow), 4000);
      }
    });

    this.loadingSubscription = this.alertService.onLoading().subscribe((loading: Loading) => {
      this.loading = loading;
    });

    // clear alerts on location change
    this.routeSubscription = this.router.events.subscribe((event: any) => {
      if (event instanceof NavigationStart) {
        this.alertService.hideAlert(this.id);
      }
    });
  }

  ngOnDestroy() {
    // unsubscribe to avoid memory leaks
    this.alertSubscription.unsubscribe();
    this.loadingSubscription.unsubscribe();
    this.routeSubscription.unsubscribe();
  }

  removeAlert(alert: Alert) {
    if (!this.alerts.find(alert => alert.Id == alert.Id)) return;
    this.alerts = this.alerts.filter((x: Alert) => x.Id !== alert.Id);
  }

  RunFunctionOnBtnClick(alert: Alert) {
    if(alert.RunFunctionOnBtnClick) {
      alert.RunFunctionOnBtnClick();
    }
    this.removeAlert(alert);
  }

  RunFunctionOnClose(alert: Alert) {
    if(alert.RunFunctionOnClose) {
      alert.RunFunctionOnClose();
    }
    this.removeAlert(alert);
  }

  cssClasses(alert: Alert) {
    if (!alert) return;
    const classes = ['alert', 'alert-dismissable'];
    //Define type:
    const alertTypeClass = {
      [AlertType.InfoLogo]: 'alert-light',
      [AlertType.Success]: 'alert-success',
      [AlertType.Error]: 'alert-danger',
      [AlertType.Info]: 'alert-info',
      [AlertType.Warning]: 'alert-warning',
    };
    classes.push(alertTypeClass[alert.Type!]);
    //Define position:
    const alertPositionClass = {
      [AlertPosition.TopLeft]: 'top-left',
      [AlertPosition.TopCenter]: 'top-center',
      [AlertPosition.TopRight]: 'top-right',
      [AlertPosition.BottomLeft]: 'bottom-left',
      [AlertPosition.BottomRight]: 'bottom-right',
    };

    if (alert.ShowAsModal)
      classes.push(alertPositionClass[AlertPosition.TopCenter]);
    else classes.push(alertPositionClass[alert.Position!]);

    return classes.join(' ');
  }
}
